import create from 'zustand';

type BlockerStore = {
    isBlocker: boolean;
    setBlocker: (isBlocker: boolean) => void;
    pendingAction: (() => void) | null;
    setPendingAction: (fn: (() => void) | null) => void;
};

export const useBlockerStore = create<BlockerStore>((set) => ({
    isBlocker: false,
    setBlocker: (isBlocker) =>
        set((state) => ({
            isBlocker: isBlocker,
        })),
    pendingAction: null,
    setPendingAction: (fn) => set({ pendingAction: fn }),
}));
